'use client'

import { SessionProvider } from "next-auth/react"
import { QueryClientProvider } from "@tanstack/react-query"
import { type ReactNode, useState } from "react"
import { SyncProvider } from "@/contexts/SyncContext"
import { StoreProvider } from "@/contexts/StoreContext"
import { createQueryClient } from "@/lib/react-query/create-client"
import { Toaster } from "@/components/ui/sonner"
import { MfaGateRedirect } from "@/components/auth/MfaGateRedirect"
import { PostHogProvider } from "@/components/providers/PostHogProvider"

export function Providers({ children }: { children: ReactNode }) {
  // QueryClientをuseStateで管理することで、
  // サーバーサイドレンダリング時の状態共有問題を回避
  const [queryClient] = useState(() => createQueryClient())

  return (
    <SessionProvider>
      <PostHogProvider>
        <MfaGateRedirect />
        <QueryClientProvider client={queryClient}>
          <StoreProvider>
            <SyncProvider>
              {children}
              <Toaster />
            </SyncProvider>
          </StoreProvider>
        </QueryClientProvider>
      </PostHogProvider>
    </SessionProvider>
  )
}
